module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie ProgressIndicator shows a pulsing circle  with option percentage complete display.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;ProgressIndicator currentPercentage={50}/&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/ProgressIndicator/README.md
// module id = 378
// module chunks = 0